/*
 * Enums do módulo de vistorias. Os valores são o contrato do backend
 * (`backend/src/models/enums/inspection-*.enum.ts`) — não renomear sem mudar lá.
 */

export enum InspectionStatusEnum {
  ToStart = 'TO_START',
  Started = 'STARTED',
  Paused = 'PAUSED',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
};

export enum InspectionSignalingStatusEnum {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Waiting = 'WAITING',
  NotCataloged = 'NOT_CATALOGED',
};

export enum InspectionSignalingModeEnum {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
};

/*
 * Condições (defeitos) que o HORUS devolve por sinalização.
 *
 * O backend do Hellius guarda `conditions` como JSON livre, sem validar contra
 * enum (`TrafficSign.conditions`, traffic-sign.ts:584) — este enum existe para o
 * lado da tela: rotular e ordenar o que chega. Valores idênticos ao
 * `SignalingConditionEnum` do backend-der-df, que é o que o HORUS emite.
 */
export enum SignalingConditionEnum {
  Normal = 'NORMAL',
  Deformed = 'DEFORMED',
  Damaged = 'DAMAGED',
  Graffitied = 'GRAFFITIED',
  Stickered = 'STICKERED',
  Perforated = 'PERFORATED',
  Vegetated = 'VEGETATED',
  Oxidized = 'OXIDIZED',
  Tilted = 'TILTED',
  Dirty = 'DIRTY',
  Faded = 'FADED',
  Peeling = 'PEELING',
  NonStandardLayout = 'NON_STANDARD_LAYOUT',
  NonCompliance = 'NON_COMPLIANCE',
  Indeterminate = 'INDETERMINATE',
};
